module.exports = __webpack_public_path__ + "static/media/dp.379cabee.jpg";